<script>
export default {
  inheritAttrs: false,

  props: {
    options: {
      type: Array,
      required: true,
    },

    error: {
      type: Boolean,
      default: false,
    },

    blankOption: {
      type: Object,
      default: null,
    },
  },

  methods: {
    onChange(event) {
      this.$emit('input', event.target.value)
      this.$emit('change')
    },
  },
}
</script>

<template>
  <div class="relative w-full">
    <select
      class="bg-white focus:outline-none border border-gray-300 appearance-none w-full rounded input"
      v-bind="$attrs"
      :class="{ 'border-error': error }"
      @change="onChange"
    >
      <option v-if="blankOption" :value="blankOption.id">{{
        blankOption.label
      }}</option>
      <option v-for="option in options" :key="option.id" :value="option.id">
        {{ option.label }}
      </option>
    </select>
    <div
      class="pointer-events-none absolute inset-y-0 right-0 flex items-center text-gray-700 mr-2"
    >
      <svg
        class="fill-current h-4 w-4"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
      >
        <path
          d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
        />
      </svg>
    </div>
  </div>
</template>
